import { ApiError } from '@area-restrita/client';
import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      onSuccess: () => {
        queryClient.invalidateQueries({ type: 'active' });
      },
    },
    queries: {
      retry: (failureCount, error) => {
        if (error instanceof ApiError) {
          if (error.statusCode === 401) return false;
        }

        return failureCount < 3;
      },
    },
  },
});

export default queryClient;
